import type { RoleCode, SessionSnapshot, UserType } from './types';

/**
 * BOLGELER — uygulamanin uc ayri yuzu.
 *
 * Bolge secimi TEK BIR YERDE yapilir: giris sonrasi yonlendirme, `/` rotasi ve
 * RequireZone hepsi burayi cagirir. Ikinci bir kopya, "girinca dogru yere
 * gidiyor ama adres cubuguna yazinca oteki bolgeye dusuyor" turunden bir
 * tutarsizlik uretirdi.
 */
export const ZONES = ['customer', 'exchange', 'admin'] as const;
export type Zone = (typeof ZONES)[number];

export const ZONE_PATHS: Readonly<Record<Zone, string>> = Object.freeze({
  customer: '/musteri',
  exchange: '/buro',
  admin: '/yonetim',
});

/** Bolge kararinin ihtiyac duydugu asgari bilgi — depoya bagimli degil. */
export type ZoneContext = Pick<SessionSnapshot, 'userType' | 'roleCode'>;

/**
 * Kullanicinin bolgesi.
 *
 * SIRA ONEMLI: `super_admin` ONCE bakilir ve /yonetim'e KILITLENIR.
 * Alinan karar: platform yoneticisi musteri ve buro bolgelerini GORMEZ. Sebep,
 * yetki eksikligi degil bilincli bir urun karari — yonetici ekranlari
 * baskasinin verisi uzerinde calisir; ayni oturumda "kendi musteri paneli"
 * gibi davranan bir yuzey, hangi kimlikle is yapildigini belirsiz birakir.
 */
export const zoneOf = (context: ZoneContext): Zone => {
  if (context.roleCode === ('super_admin' satisfies RoleCode)) return 'admin';
  return context.userType === ('exchange' satisfies UserType) ? 'exchange' : 'customer';
};

/** Kullanicinin acilis rotasi. Giris sonrasi ve `/` icin tek dogruluk kaynagi. */
export const zoneHome = (context: ZoneContext): string => ZONE_PATHS[zoneOf(context)];
